import { TaskModel } from '@bryntum/gantt';
import { isEmpty } from 'lodash';
import uniqBy from 'lodash/uniqBy';
import { useEffect, useMemo, useState } from 'react';
import {
  useProjectBaselineByProjectId,
  useProjectPhaseByProjectId,
} from 'data/projects';
import { useTasksByProjectId } from 'data/tasks/hooks';
import {
  getDependenciesData,
  mapPhases,
  getGanttPhaseList,
  getGanttTaskList,
  getBaselineList,
} from '../helpers';
import { BaselineList } from '../types';
import { weekendConfig } from './weekend-config';

export const useGanttDataConfig = ({ projectId }: { projectId: number }) => {
  const projectPhases = useProjectPhaseByProjectId(projectId);
  const tasks = useTasksByProjectId(projectId);
  const { data: baselines, isLoading: isFetchingBaselines } =
    useProjectBaselineByProjectId(projectId);
  const [initialised, setInitialised] = useState(false);
  // TODO: to fix the type instead of any
  const [eventsData, setEventsData] = useState([] as any[]);
  const [baselineList, setBaselineList] = useState({} as BaselineList);

  useEffect(() => {
    if (
      !initialised &&
      !isEmpty(projectPhases) &&
      !isEmpty(tasks) &&
      !isFetchingBaselines
    ) {
      setInitialised(true);
      const phaseIds = projectPhases.map((_phase) => _phase.projectPhaseId);
      const taskIds = tasks.map((_task) => _task.taskId);

      const _baselineList = getBaselineList(baselines, phaseIds, taskIds);

      setBaselineList(_baselineList);
      setEventsData(
        mapPhases(
          projectPhases.map((phase) => phase.projectPhaseId),
          getGanttPhaseList(projectPhases, _baselineList.phases),
          getGanttTaskList(tasks, _baselineList.tasks),
        ),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectPhases, tasks, baselines, isFetchingBaselines]);

  return useMemo(
    () => ({
      project: {
        taskModelClass: TaskModel,
        eventsData,
        dependenciesData: uniqBy(
          getDependenciesData(
            getGanttPhaseList(projectPhases, baselineList.phases),
            getGanttTaskList(tasks, baselineList.tasks),
          ),
          'id',
        ),
        timeRangeStore: weekendConfig,
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [eventsData, baselineList],
  );
};
